export default "__VITE_ASSET__l43djCMN__"